var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loadingGraph)?_c('pulse-loader',{staticClass:"mt-5 text-center"}):_c('GChart',{attrs:{"type":"AreaChart","data":_vm.piChartData,"options":_vm.piChartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }